/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  BulkMoveFolderDocumentsResponseData,
  BulkMoveFolderDocumentsResponseDataFromJSON,
  BulkMoveFolderDocumentsResponseDataFromJSONTyped,
  BulkMoveFolderDocumentsResponseDataToJSON
} from './BulkMoveFolderDocumentsResponseData'

/**
 *
 * @export
 * @interface IgnoreErrorsContactsEmailTransactionsResponse
 */
export interface IgnoreErrorsContactsEmailTransactionsResponse {
  /**
   *
   * @type {BulkMoveFolderDocumentsResponseData}
   * @memberof IgnoreErrorsContactsEmailTransactionsResponse
   */
  data?: BulkMoveFolderDocumentsResponseData
}

export function IgnoreErrorsContactsEmailTransactionsResponseFromJSON(
  json: any
): IgnoreErrorsContactsEmailTransactionsResponse {
  return IgnoreErrorsContactsEmailTransactionsResponseFromJSONTyped(json, false)
}

export function IgnoreErrorsContactsEmailTransactionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IgnoreErrorsContactsEmailTransactionsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: !exists(json, 'data') ? undefined : BulkMoveFolderDocumentsResponseDataFromJSON(json['data'])
  }
}

export function IgnoreErrorsContactsEmailTransactionsResponseToJSON(
  value?: IgnoreErrorsContactsEmailTransactionsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: BulkMoveFolderDocumentsResponseDataToJSON(value.data)
  }
}
